"use strict";

(function ($) {
  $("document").ready(function () {

  	if(document.getElementById('user-re-password')){
	  document.getElementById('user-re-password').addEventListener("keyup", checkPass);
	}

	if(document.getElementById('user-password')){
  		document.getElementById('user-password').addEventListener("keyup", checkPass);
	}

	if(document.getElementById('user-re-email')){
		document.getElementById('user-re-email').addEventListener("keyup", checkEmail);
	}

	if(document.getElementById('user-email')){
		document.getElementById('user-email').addEventListener("keyup", checkEmail);
	}



	  //add_new_user_regostration_form
	  $('#add_new_user_regostration_form').on('submit', function(e) {
		  e.preventDefault();
		  const add_new_user_regostration_form = $("#add_new_user_regostration_form");
		  const formData = new FormData(add_new_user_regostration_form[0]);
		  const rest_endpoint = add_new_user_regostration_form.attr('action');

		  const request = $.ajax({
			  url: rest_endpoint,
			  method: "POST",
			  data: formData,
			  async: false,
			  cache: false,
			  contentType: false,
			  processData: false,
			  beforeSend: function (xhr) {
				  xhr.setRequestHeader('X-WP-Nonce', add_new_user_regostration_form.find('input[name="rest_auth_nonce"]').val());
			  }
		  });

		  request.done(function (msg) {
			  //console.log(msg);
			  if(msg.error == 1){
				  jQuery('#registrationFailUserExistsModal').modal('toggle');
			  }else{
				  jQuery('#registrationModal').modal('toggle');
				  setTimeout(function(){
					  window.location.replace("konto-dane-postawowe");
					  document.location.href='konto-dane-postawowe'
				  },2000)
			  }
		  });
		  request.fail(function (jqXHR, textStatus) {
			  //console.log(jqXHR,textStatus);
			  jQuery('#registrationFailModal').modal('toggle');
		  });
	  });
  });



	function checkPass(){
		var userPassword = $('#user-password').val();
		var userRePassword = $('#user-re-password').val();

		if(userPassword != '' && userRePassword != ''){
			if(userRePassword == userPassword){
				$('#user-password').removeClass('error');
				$('#user-re-password').removeClass('error');
				$('.registration-submit').removeClass('disabled-btn');

			}else{
				$('#user-password').addClass('error');
				$('#user-re-password').addClass('error');
				$('.registration-submit').addClass('disabled-btn');
			}
		}
	}
	function checkEmail(){
		var userEmail = $('#user-email').val();
		var userReEmail = $('#user-re-email').val();

		if(userEmail != '' && userReEmail != ''){
			if(userReEmail == userEmail){
				$('#user-email').removeClass('error');
				$('#user-re-email').removeClass('error');
				$('.registration-submit').removeClass('disabled-btn');

			}else{
				$('#user-email').addClass('error');
				$('#user-re-email').addClass('error');
				$('.registration-submit').addClass('disabled-btn');
			}
		}
	}
})(jQuery);
